import { GeoSource, PlatformSource } from "../@types"
import { PlatformProfile } from "./platformProfile"
import {
  createPlatformTestObjectOverrides,
  PlatformTestObjectOverrides,
} from "./platformTestObjectOverrides"
import {
  assertNonEmptyString,
  assertObject,
  assertString,
} from "./sessionConfigValidation"

export interface Platform {
  cdnResponseHeader: string | undefined
  dopplerPlatformID: string
  geoRules: GeoSource | undefined
  platformHostname: string
  platformProfile: PlatformProfile
  pulsarAppID: string | undefined
  pulsarJobID: string | undefined
  testObjectOverrides: PlatformTestObjectOverrides[] | undefined
}

export const createPlatform: (
  source: PlatformSource,
  profile: PlatformProfile,
) => Platform = (s, p) => new PlatformImpl(s, p)

class PlatformImpl implements Platform {
  private _cdnResponseHeader?
  private _dopplerPlatformID: string
  private _geoRules
  private _platformHostname
  private _pulsarAppID?
  private _pulsarJobID?
  private _testObjectOverrides
  constructor(
    source: PlatformSource,
    private _platformProfile: PlatformProfile,
  ) {
    /* eslint-disable @typescript-eslint/dot-notation */
    const tempDopplerSource = source["doppler"]
    assertObject("doppler", tempDopplerSource)
    const tempDopplerPlatformID = tempDopplerSource["id"]
    assertString("doppler.id", tempDopplerPlatformID)
    this._dopplerPlatformID = tempDopplerPlatformID
    const tempPulsarSource = source["pulsar"]
    if (tempPulsarSource) {
      const tempPulsarAppID = tempPulsarSource["app_id"]
      if (tempPulsarAppID) {
        this._pulsarAppID = tempPulsarAppID
      }
      const tempPulsarJobID = tempPulsarSource["job_id"]
      if (tempPulsarJobID) {
        this._pulsarJobID = tempPulsarJobID
      }
    }
    const tempHostname = source["hostname"]
    assertNonEmptyString("hostname", tempHostname)
    this._platformHostname = tempHostname.trim()
    const tempCdnResponseHeader = source["cdn_response_header"]
    if (
      typeof tempCdnResponseHeader === "string" &&
      tempCdnResponseHeader.length
    ) {
      this._cdnResponseHeader = tempCdnResponseHeader
    } else {
      this._cdnResponseHeader = _platformProfile.cdnResponseHeader
    }
    this._geoRules = source["geo"]
    const tempTestObjectOverrides = source["objects"]
    if (tempTestObjectOverrides) {
      this._testObjectOverrides = tempTestObjectOverrides.map((source) =>
        createPlatformTestObjectOverrides(source),
      )
    }
    /* eslint-enable @typescript-eslint/dot-notation */
  }

  get cdnResponseHeader() {
    return this._cdnResponseHeader
  }

  get dopplerPlatformID() {
    return this._dopplerPlatformID
  }

  get geoRules() {
    return this._geoRules
  }

  get platformHostname() {
    return this._platformHostname
  }

  get platformProfile() {
    return this._platformProfile
  }

  get pulsarAppID() {
    return this._pulsarAppID
  }

  get pulsarJobID() {
    return this._pulsarJobID
  }

  get testObjectOverrides() {
    return this._testObjectOverrides
  }
}
